// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1LDQP","header":"PatientBlock_header__35S9s","label":"PatientBlock_label__3BTi-","option":"PatientBlock_option__2MouD"};